import React, { FC, useEffect, useContext, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import ReactTable from "../Components/Table6/Table6";
import { Button } from "reactstrap";

import { initReactI18next, useTranslation } from "react-i18next";
import moment from "moment/moment";

import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";

import { useState } from "react";
import { toNumber } from "config/util";

const App = ({
  dispatch_put_markets_exchanges_id_cancel,
  searchHistoriesOrders,
  set_searchHistoriesOrders,
  set_modalHistoriesOrders,
  set_alert,
  searchUsers,
  data_tables,
  inLoading,
}) => {
  const ref = useRef();
  const [t, i18n] = useTranslation();
  const maps = useSelector((state) => state.reduce_get_maps);

  const useStyles = makeStyles({
    table: {
      minWidth: 650,
    },
  });
  const classes = useStyles();
  return (
    <>
      <TableContainer component={Paper}>
      <Table className="table-striped" aria-label="a dense table">
          <TableHead>
            <TableRow style={{ whiteSpace: "nowrap" }}>
              <TableCell align="left">{t("実行日時")}</TableCell>
              <TableCell align="right">{t("取引通貨")}</TableCell>
              <TableCell align="right">{t("種別")}</TableCell>
              <TableCell align="right">{t("ステータス")}</TableCell>
              <TableCell align="right">{t("数量")}</TableCell>
              <TableCell align="right">{t("残高")}</TableCell>
              <TableCell align="right">{t("価格")}</TableCell>
              {/* <TableCell align="right">{t("トリガー価格")}</TableCell> */}

              {/* <TableCell align="right">{t("損益")}</TableCell>
              <TableCell align="right">{t("制限")}</TableCell>
              <TableCell align="right">{t("停止")}</TableCell> */}
            </TableRow>
          </TableHead>
          <TableBody>
            {data_tables.map((prop, idx) => {
              const props = {
                id: prop.order_id,

                symbol: prop.symbol,
                amount: prop.amount,
                compare_amount: prop.compare_amount,
                trigger_amount:
                  prop.trigger_amount === prop.compare_amount
                    ? ""
                    : prop.trigger_amount,
                limit: prop.limit,
                profit_loss: prop.profit_loss,
                residue_amount: prop.residue_amount,
                stop: prop.stop,
                type: prop.type,
                executed_at: prop.executed_at,
                executed_at_label: prop.executed_at
                  ? moment
                      .utc(prop.executed_at)
                      .local()
                      .format("YY/MM/DD HH:mm")
                  : "",
                type_label: maps.order_types[prop.type],
                // status_label: maps.order_status[prop.status],
                status_label: maps.order_statuses[prop.status],
                // status_label: prop.status,
              };

              return (
                <TableRow key={prop.order_id} style={{ whiteSpace: "nowrap" }}>
                  <TableCell align="left">{props.executed_at_label}</TableCell>
                  <TableCell align="right">{props.symbol}</TableCell>
                  <TableCell align="right">{t(props.type_label)}</TableCell>
                  <TableCell align="right">{t(props.status_label)}</TableCell>
                  <TableCell align="right">{toNumber(props.amount,maps.coin_decimals[props.symbol].amount)}</TableCell>
                  <TableCell align="right">{toNumber(props.residue_amount,maps.coin_decimals[props.symbol].amount)}</TableCell>
                  <TableCell align="right">{toNumber(props.compare_amount,maps.coin_decimals[props.symbol].price)}</TableCell>
                  {/* <TableCell align="right">{props.trigger_amount}</TableCell> */}
                  {/* <TableCell align="right">{props.profit_loss}</TableCell>
                <TableCell align="right">{props.limit}</TableCell>
                <TableCell align="right">{props.stop}</TableCell> */}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default App;
